import React, { useState } from 'react'
import styled from 'styled-components'
import { StringUtils } from 'main/common/utils/StringUtils'
import { PopOverCP } from 'main/common/components/pop-over/PopOverCP'
import { ButtonCP } from 'main/common/components/button/ButtonCP'
import { AutocompleteUserCP } from 'main/modules/user/components/autocomplete-user/AutocompleteUserCP'
import { INameAndCodeResponseDTO } from 'main/common/dtos/responses/INameAndCodeResponseDTO'
import { TextCP } from 'main/common/components/text/TextCP'
import { ConditionalRenderCP } from 'main/common/components/conditional-render/ConditionalRenderCP'
import { PermissionUtils } from 'main/modules/auth/utils/PermissionUtils'
import { PermissionEnum } from 'submodules/neritclin-sdk/services/user/enums/PermissionEnum'

interface ICPProps {
    user: INameAndCodeResponseDTO
    onSelectUser: (user: INameAndCodeResponseDTO) => void
}

/**
 * Texto do usuário com selecao de uma pessoa para titulo do dashboard.
 */
export function DashboardUserTitleCP(props: ICPProps): JSX.Element {

    const [isUserPopoverVisible, setIsUserPopoverVisible] = useState<boolean>(false)

    return (
        <PersonTitleSCP>
            <TextCP text={'Indicadores de Performance da:'}/>
            <TextCP text={StringUtils.getFirstAndSecondName(props.user.name)} strong={true} marginLeft={5}/>

            <ConditionalRenderCP shouldRender={PermissionUtils.hasAccess(undefined, [PermissionEnum.ROLE_DASHBOARD_MANAGER])}>
                <PopOverCP
                    content={
                        <AutocompleteUserCP
                            label={'Filtre por outra avaliadora'}
                            showOptionsOnLoad={true}
                            width={300}
                            returnFullOption={true}
                            onChange={(selected) => {
                                if (!!selected) {
                                    props.onSelectUser({ code: selected.value, name: selected.label })
                                    setIsUserPopoverVisible(false)
                                }
                            }}
                        />
                    }
                    onClose={() => setIsUserPopoverVisible(false)}
                    visible={isUserPopoverVisible}
                >
                    <ButtonCP
                        icon={'edit'}
                        marginLeft={10}
                        type={'link'}
                        onClick={() => setIsUserPopoverVisible(true)}
                    />
                </PopOverCP>
            </ConditionalRenderCP>
        </PersonTitleSCP>
    )
}

const PersonTitleSCP = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 0 30px 0;
  
  b {
    color: #f59873;
  }
`
